
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1afkv_i99li_5",
  "dropdown": "awsui_dropdown_1afkv_i99li_6",
  "label": "awsui_label_1afkv_i99li_7",
  "relative-range-radio-group": "awsui_relative-range-radio-group_1afkv_i99li_8",
  "custom-range-duration-input": "awsui_custom-range-duration-input_1afkv_i99li_9",
  "custom-range-unit-select": "awsui_custom-range-unit-select_1afkv_i99li_10",
  "mode-switch": "awsui_mode-switch_1afkv_i99li_11",
  "first-grid": "awsui_first-grid_1afkv_i99li_12",
  "second-grid": "awsui_second-grid_1afkv_i99li_13",
  "calendar-header": "awsui_calendar-header_1afkv_i99li_14",
  "calendar-next-page-btn": "awsui_calendar-next-page-btn_1afkv_i99li_15",
  "calendar-prev-page-btn": "awsui_calendar-prev-page-btn_1afkv_i99li_16",
  "calendar-next-month-btn": "awsui_calendar-next-month-btn_1afkv_i99li_17",
  "calendar-prev-month-btn": "awsui_calendar-prev-month-btn_1afkv_i99li_18",
  "calendar-aria-live": "awsui_calendar-aria-live_1afkv_i99li_19",
  "calendar-date": "awsui_calendar-date_1afkv_i99li_20",
  "calendar-week": "awsui_calendar-week_1afkv_i99li_21",
  "calendar-month": "awsui_calendar-month_1afkv_i99li_22",
  "calendar-quarter": "awsui_calendar-quarter_1afkv_i99li_23",
  "today": "awsui_today_1afkv_i99li_24",
  "this-month": "awsui_this-month_1afkv_i99li_25",
  "day-header": "awsui_day-header_1afkv_i99li_26",
  "start-date": "awsui_start-date_1afkv_i99li_27",
  "end-date": "awsui_end-date_1afkv_i99li_28",
  "start-time-input": "awsui_start-time-input_1afkv_i99li_29",
  "end-time-input": "awsui_end-time-input_1afkv_i99li_30",
  "start-date-input": "awsui_start-date-input_1afkv_i99li_31",
  "end-date-input": "awsui_end-date-input_1afkv_i99li_32",
  "start-month-input": "awsui_start-month-input_1afkv_i99li_33",
  "end-month-input": "awsui_end-month-input_1afkv_i99li_34",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_1afkv_i99li_35",
  "validation-section": "awsui_validation-section_1afkv_i99li_36",
  "validation-error": "awsui_validation-error_1afkv_i99li_37",
  "clear-button": "awsui_clear-button_1afkv_i99li_38",
  "apply-button": "awsui_apply-button_1afkv_i99li_39",
  "cancel-button": "awsui_cancel-button_1afkv_i99li_40"
};
  